// src/packages/msig/pa/msig_pa_triple_care_2025/MSIGTripleCareCard.jsx
import React from "react";
import "./msig_triple_care.css";

export default function MSIGTripleCareCard({ onSelect }) {
  return (
    <div className="pkg-card msig-pa-triple">
      <div className="pkg-body">
        <h3>MSIG PA Triple Care (แผน 1–9)</h3>
        <p>อุบัติเหตุส่วนบุคคล • ค่ารักษา • กระดูกแตก • ทันตกรรม • ชดเชยรายวัน*</p>
        <ul className="pkg-list">
          <li>ทุนชีวิต/ทุพพลภาพ สูงสุดถึง 2,000,000 บาท</li>
          <li>ค่ารักษา สูงสุด 200,000 บาท/ครั้ง</li>
          <li>ชดเชยรายวัน (บางแผน) วันละ 500 บาท สูงสุด 30 วัน</li>
        </ul>
        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
